import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './App';
import { theme, darkTheme } from './theme';
import { BrowserRouter } from 'react-router-dom';
import SimpleReactLightbox from 'simple-react-lightbox';

// Limit roboto imports to font weights used by Material-UI
import "@fontsource/roboto/300.css" // Weight 300.
import "@fontsource/roboto/400.css" // Weight 400.
import "@fontsource/roboto/500.css" // Weight 500.
import "@fontsource/roboto/700.css" // Weight 700.

ReactDOM.render(
  
    <ThemeProvider theme={darkTheme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <BrowserRouter>
        <SimpleReactLightbox>
          <App />
        </SimpleReactLightbox>
      </BrowserRouter>
    </ThemeProvider>,
  document.querySelector('#root'),
);